export default __webpack_public_path__ + "assets/south-africa-flag.png";